//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ColFilter from "@/components/FilterTable/ColFilter.vue";
import moment from "moment";
export default {
  name: "filter-table-table",
  props: [
    "tableClass",
    "bordered",
    "columns",
    "data",
    "title",
    "recordsTotal",
    "loading",
    "canFilter",
    "separator",
    "selection",
    "selected",
    "hasSecondaryExport",
    "hideRemoveButtons",
    "pageSize",
    "refreshable",
    "searchEnabled",
    "searchDateEnabled",
    "showMoreOptions"
  ],
  components: {
    ColFilter,
  },
  mounted: function () {
    this.deletionAlert = new Array(this.data.length).fill(false);
    if (this.showMoreOptions === false) {
      this.showOptions = this.showMoreOptions;
    }
    this.isClicked = Array(this.data.length).fill(false);
  },
  data: function () {
    return {
      pagination: {
        rowsPerPage: this.pageSize ? this.pageSize : 10,
        page: 1,
        rowsNumber: this.recordsTotal,
      },
      showOptions: true,
      search: "",
      searchDateType: "ref_date",
      searchDate: null,
      orderedSort: [],
      extraInfo: {},
      visibleColumns: this.columns.map((element) => element.name),
      renderedColumns: [
        ...new Set(
          this.columns.map((element) =>
            element.group ? element.group : element.name
          )
        ),
      ],
      deletionAlert: [],
      isClicked: [],
      lastSelectedItemPage: null,
      lastSelectedItemRow: null,
      sortStatus: Array(this.columns.length).fill(null),
      appliedFilters: [],
      filterData: Object.assign(
        {},
        Array(this.columns.length)
          .fill({})
          .map((item, index) => ({
            index: index,
            column_key: this.columns[index].name,
            fieldFunc: this.columns[index].field,
            exclude: [""],
            include: null,
          }))
      ),
    };
  },
  methods: {
    functionCustom: function (column, index, state) {
      this.$set(this.extraInfo[column], index, state);
    },
    clearSelection: function () {
      this.isClicked = Array(this.data.length).fill(false);
      this.lastSelectedItemPage = null;
      this.lastSelectedItemRow = null;
    },
    // fetchRowData: function(index) {
    //   let indexOnLine = index % this.pagination.rowsPerPage;
    //   let data = this.data[indexOnLine];
    //   this.$emit("clicked-row", data);
    // },
    // getUniqueOptions: function(tableProps) {
    //   if (this.data.length) {
    //     let data = [...new Set(this.data.map(tableProps.field))];
    //     data = data.map(value => (value ? value : "N/A"));
    //     return data;
    //   }
    //   return [];
    // },
    // applyData: function(event, column, index) {
    //   if (event.invertSort) {
    //     this.$refs.table.sort(column);
    //     this.sortStatus[index] = !this.sortStatus[index];
    //   }
    //   if (event.selectedItems && event.selectedItems.length) {
    //     this.filterData[index].exclude = null;
    //     this.filterData[index].include = event.selectedItems;
    //   } else {
    //     this.filterData[index].include = null;
    //     this.filterData[index].exclude = [""];
    //   }
    //   this.$emit("filter-changed", this.filterData);
    // },
    displayDeletePopup(index) {
      this.deletionAlert[index] = true;
    },
    filterTable(rows, terms, cols) {
      let result = [];
      for (let row of rows) {
        let toInsert = Array(cols.length).fill(false);
        for (let filterIndex in terms) {
          if (terms[filterIndex].include) {
            for (let searchTerm of terms[filterIndex].include) {
              if (searchTerm === terms[filterIndex].fieldFunc(row)) {
                toInsert[filterIndex] = true;
                break;
              }
            }
          }
          if (terms[filterIndex].exclude) {
            let toExclude = false;
            for (let searchTerm of terms[filterIndex].exclude) {
              if (
                searchTerm === terms[filterIndex].fieldFunc(row) &&
                searchTerm.length
              ) {
                toExclude = true;
                break;
              }
            }
            if (!toExclude) {
              toInsert[filterIndex] = true;
            }
          }
        }
        if (toInsert.reduce((result, current) => result && current, true)) {
          result.push(row);
        }
      }
      return result;
    },
    fetchRowData: function (index) {
      let indexOnLine = this.pagination.rowsNumber
        ? index % this.pagination.rowsPerPage
        : index;
      let data = this.data[indexOnLine];
      let isLineSelected = this.isClicked[indexOnLine];
      this.isClicked = Array(this.data.length).fill(false);
      this.isClicked.splice(indexOnLine, 1, !isLineSelected);
      if (isLineSelected) {
        this.lastSelectedItemPage = null;
        this.lastSelectedItemRow = null;
        this.$emit("clicked-row", null);
      } else {
        this.lastSelectedItemPage = this.pagination.page;
        this.lastSelectedItemRow = indexOnLine;
        this.$emit("clicked-row", data);
      }
    },
    getUniqueOptions: function (tableProps) {
      if (this.data.length) {
        let data = [...new Set(this.data.map(tableProps.field))];
        data = data.map((value) => (value ? value : "N/A"));
        return data;
      }
      return [];
    },
    applyData: function (event, column, index) {
      if (this.appliedFilters === []) {
        this.appliedFilters = Array(this.columns.length).fill(false);
      }

      this.sortStatus[index] = event.sortState;

      if (this.sortStatus[index] !== null) {
        let itemIndex = this.orderedSort.findIndex((item) =>
          item.includes(name)
        );
        let fieldSort = [column.name];
        fieldSort.push(this.sortStatus[index] ? "asc" : "desc");
        if (itemIndex < 0) {
          this.orderedSort.push(fieldSort.join(","));
        } else {
          this.orderedSort[itemIndex] = fieldSort.join(",");
        }
      }

      this.sortIcon(index);
      if (event.selectedItems && event.selectedItems.length) {
        this.filterData[index].exclude = null;
        this.filterData[index].include = event.selectedItems;
        this.appliedFilters[index] = true;
      } else {
        this.filterData[index].include = null;
        this.filterData[index].exclude = [""];
        this.appliedFilters[index] = false;
      }
      this.$emit("filter-changed", {
        filters: this.filterData,
        sort: this.orderedSort,
      });
    },
    sortIcon: function (index) {
      if (this.sortStatus[index] !== null) {
        return this.sortStatus[index] ? "mdi-arrow-up" : "mdi-arrow-down";
      } else {
        return "mdi-circle-outline";
      }
    },
    updateState: function (event) {
      this.pagination = event.pagination;
      event.sort = this.orderedSort;
      event.search = this.search;
      event.searchDate = this.searchDate;
      this.$emit("request-new-page", event);
    },
    updateVisibleColumns: function ({ value }) {
      let event = value;
      let cols = this.columns.filter((element) => element.group === event);

      if (cols.length) {
        cols = cols.map((element) => element.name);

        this.visibleColumns = this.visibleColumns
          .filter((x) => !cols.includes(x))
          .concat(cols.filter((x) => !this.visibleColumns.includes(x)));
      } else {
        let index = this.visibleColumns.lastIndexOf(event);

        if (index < 0) {
          this.visibleColumns.push(event);
        } else {
          this.visibleColumns.splice(index, 1);
        }
      }
    },
    customComponentPropsIcon: function (column) {
      let props = {};
      if (column.icon.content.customComponentProps) {
        Object.keys(column.icon.content.customComponentProps).forEach((key) => {
          props[key] = column[column.icon.content.customComponentProps[key]];
        });
      }
      return props;
    },
    componentProps: function (column) {
      let props = {};
      if (column.component.props) {
        Object.keys(column.component.props).forEach((key) => {
          props[key] = column[column.component.props[key]];
        });
      }
      return props;
    },
    customComponentProps: function (column) {
      let props = {};
      if (column.icon.content.customComponentProps) {
        Object.keys(column.icon.content.customComponentProps).forEach((key) => {
          props[key] = column[column.icon.content.customComponentProps[key]];
        });
      }
      return props;
    },
    searchEvent: function () {
      if (this.search.length === "") {
        this.pagination.page = 1;
      }
      let event = {
        pagination: this.pagination,
        sort: this.orderedSort,
        filters: this.filterData,
        search: this.search,
      };


      this.updateState(event)
    },
    searchDateEvent: function () {
      //{ date: moment(new Date()).format("YYYY-MM-DD"), searchDateType: "ref_date" },
      if (this.search.length === "") {
        this.pagination.page = 1;
      }
      let event = {
        pagination: this.pagination,
        sort: this.orderedSort,
        filters: this.filterData,
        searchDate: moment(this.searchDate).format("YYYY-MM-DD"),
        searchDateType: this.searchDateType,
      };
      this.updateState(event)
    },
    eraseDateEvent: function () {
      if (this.searchDate == null) {
        return;
      }
      this.searchDate = null;
      this.searchDateEvent();
    },
    eraseEvent: function () {
      if (this.search === "") {
        return;
      }
      this.search = "";
      this.searchEvent();
    },
  },
  computed: {
    filteredOptions: function () {
      let resultingObjectArray = [];

      this.columns.forEach((element) => {
        if (element.group) {
          resultingObjectArray.push({
            name: element.group,
            label: `Campos ${element.group}`,
          });
        } else {
          resultingObjectArray.push(element);
        }
      });

      resultingObjectArray = resultingObjectArray.filter(
        (v, i, a) =>
          a.findIndex((t) => t.label === v.label && t.name === v.name) === i
      );
      return resultingObjectArray;
    },
  },
  watch: {
    recordsTotal: function (newVal) {
      // watch it
      this.pagination.rowsNumber = newVal;
    },
    data: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.columns
          .filter((column) => column.icon)
          .forEach((column) => {
            this.$set(this.extraInfo, column.name, {});
            for (let i = 0; i < newVal.length; i++) {
              this.$set(this.extraInfo[column.name], i, false);
            }
          });

        if (this.pagination.page === this.lastSelectedItemPage) {
          this.isClicked.splice(this.lastSelectedItemRow, 1, true);
        }
      },
    },
  },
};
